import { createContext, createRef } from 'react';
import type { DSComboboxT } from './react-desc-prop-types.js';
import type { DSComboboxInternalsT } from './sharedTypes.js';
// eslint-disable-next-line @typescript-eslint/no-empty-function

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
export function noop<T extends unknown[]>(..._args: T): void {}

export const defaultProps: DSComboboxT.DefaultProps = {
  hasError: false,
  inline: false,
  withoutPortal: false,
  disabled: false,
  useMask: noop,
  innerRef: createRef(),
  startPlacementPreference: 'bottom-start',
  placementOrderPreference: ['bottom-start', 'top-start'],
  noOptionsMessage: 'No Matches Found',
  isNonClearable: false,
  onlySelectable: false,
  isSkeleton: false,
  // override in useCombobox to avoid ref duplications when more than one cb is used
  applyAriaDisabled: false,
  readOnly: false,
  isMenuOpenableWithReadOnly: false,
  forceFocusFirstOptionOnType: false,
};

const defaultContext = {} as DSComboboxInternalsT.ComboBoxContextT;
/** Context for cross component communication */
export const ComboBoxContext = createContext(defaultContext);

export default ComboBoxContext;
